module.exports = __webpack_public_path__ + "img/club_ad04.40bab7f9.jpg";